import { useApiMutation, useLocalizedApiQuery } from "../services/react-query";

export const useCreateRegistrationCustomField = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useCreateRegistrationCustomField" },
    fetchOptions: { url: "/registration-custom-fields", method: "POST" },
    invalidateQueryKeys: [["registrationCustomFields"]],
    successMessage: {
      title: "Registration custom field has been created",
      color: "green",
    },
  });

export const useGetRegistrationCustomFields = (eventId) =>
  useLocalizedApiQuery({
    queryOptions: { queryKey: ["registrationCustomFields", eventId] },
    fetchOptions: {
      url: "/registration-custom-fields",
      method: "GET",
      params: { eventId },
    },
  });

export const useOrderRegistrationCustomFields = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useOrderRegistrationCustomFields" },
    fetchOptions: {
      url: `/registration-custom-fields/order`,
      method: "PATCH",
    },
    successMessage: {
      title: "Custom fields reordered successfully",
      color: "green",
    },
    invalidateQueryKeys: [["registrations"]],
  });

export const useUpdateRegistrationCustomField = (id) =>
  useApiMutation({
    mutationOptions: { mutationKey: "usePatchRegistrationCustomField" },
    fetchOptions: { url: `/registration-custom-fields/${id}`, method: "PATCH" },
    invalidateQueryKeys: [["registrationCustomFields"]],
    successMessage: {
      title: "Registration custom field has been updated",
      color: "green",
    },
  });

export const useDeleteRegistrationCustomField = (id) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useDeleteRegistrationCustomField" },
    fetchOptions: {
      url: `/registration-custom-fields/${id}`,
      method: "DELETE",
    },
    invalidateQueryKeys: [["registrationCustomFields"]],
    successMessage: {
      title: "Registration custom field has been deleted",
      color: "green",
    },
  });
